(function () {
  "use strict";

  var mapboxScriptUrl = "https://api.mapbox.com/mapbox-gl-js/v3.20.0/mapbox-gl.js";
  var mapboxCssUrl = "https://api.mapbox.com/mapbox-gl-js/v3.20.0/mapbox-gl.css";
  var googleScriptBase = "https://maps.googleapis.com/maps/api/js";
  var leafletScriptUrl = "https://unpkg.com/leaflet@1.9.4/dist/leaflet.js";
  var leafletCssUrl = "https://unpkg.com/leaflet@1.9.4/dist/leaflet.css";

  function decodeHtmlEntities(value) {
    if (!value) return "";
    var textarea = document.createElement("textarea");
    textarea.innerHTML = value;
    return textarea.value;
  }

  function safeParseJson(text) {
    if (!text || !text.trim()) return null;
    try {
      return JSON.parse(text);
    } catch (_error) {
      return null;
    }
  }

  function normalizeText(value) {
    return String(value || "")
      .trim()
      .toLowerCase();
  }

  function isZipCode(value) {
    return /^\d{5}(?:-\d{4})?$/.test(String(value || "").trim());
  }

  function extractImageUrl(value) {
    if (!value) return "";
    if (typeof value === "string") {
      var s = value.trim();
      return /^https?:\/\//i.test(s) ? s : "";
    }
    if (typeof value === "object") {
      if (typeof value.url === "string") return value.url;
      if (typeof value.src === "string") return value.src;
      if (value.image && typeof value.image.src === "string") return value.image.src;
      if (value.preview_image && typeof value.preview_image.src === "string") return value.preview_image.src;
    }
    return "";
  }

  function haversineMiles(lat1, lng1, lat2, lng2) {
    var toRad = function (deg) {
      return (deg * Math.PI) / 180;
    };
    var radius = 3958.8;
    var dLat = toRad(lat2 - lat1);
    var dLng = toRad(lng2 - lng1);
    var a =
      Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
    var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return radius * c;
  }

  function normalizeLocation(raw, index) {
    if (!raw || typeof raw !== "object") return null;

    var name = String(raw.name || "").trim();
    var address = String(raw.address || "").trim();
    var city = String(raw.city || "").trim();
    var state = String(raw.state || "").trim();
    var zip = String(raw.zip || "").trim();
    var notes = String(raw.notes || "").trim();
    var logoUrl = extractImageUrl(raw.logo_url || raw.logo || raw.image);
    var latitude = raw.latitude === null || raw.latitude === undefined || raw.latitude === "" ? null : Number(raw.latitude);
    var longitude = raw.longitude === null || raw.longitude === undefined || raw.longitude === "" ? null : Number(raw.longitude);
    var sortOrder = raw.sort_order === null || raw.sort_order === undefined || raw.sort_order === "" ? null : Number(raw.sort_order);
    var isActive = raw.is_active === false ? false : true;

    if (!name || !address || !city || !state || !zip || !isActive) {
      return null;
    }

    if (latitude !== null && (!Number.isFinite(latitude) || latitude < -90 || latitude > 90)) {
      latitude = null;
    }
    if (longitude !== null && (!Number.isFinite(longitude) || longitude < -180 || longitude > 180)) {
      longitude = null;
    }
    if (sortOrder !== null && !Number.isFinite(sortOrder)) {
      sortOrder = null;
    }

    return {
      id: index + "-" + name + "-" + zip,
      name: name,
      address: address,
      city: city,
      state: state,
      zip: zip,
      notes: notes,
      logo_url: logoUrl,
      latitude: latitude,
      longitude: longitude,
      sort_order: sortOrder,
      searchText: normalizeText([name, address, city, state, zip].join(" "))
    };
  }

  function buildDirectionsUrl(location) {
    if (location.latitude !== null && location.longitude !== null) {
      return "https://www.google.com/maps?q=" + encodeURIComponent(location.latitude + "," + location.longitude);
    }
    var destination = [location.address, location.city, location.state, location.zip].filter(Boolean).join(", ");
    return "https://www.google.com/maps/search/?api=1&query=" + encodeURIComponent(destination);
  }

  function escapeHtml(value) {
    return String(value || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function createLocationCard(location) {
    var card = document.createElement("article");
    card.className = "store-locator__item";
    card.setAttribute("data-store-item", "");

    var content = document.createElement("div");
    content.className = "store-locator__item-content";

    card.appendChild(content);

    if (location.logo_url) {
      var media = document.createElement("div");
      media.className = "store-locator__item-media";

      var logo = document.createElement("img");
      logo.className = "store-locator__item-logo";
      logo.src = location.logo_url;
      logo.alt = location.name;
      logo.loading = "lazy";
      logo.width = 96;
      logo.height = 96;
      media.appendChild(logo);
      card.appendChild(media);
    }

    var name = document.createElement("h3");
    name.className = "store-locator__item-name";
    name.textContent = location.name;
    content.appendChild(name);

    if (typeof location.distanceMiles === "number") {
      var distance = document.createElement("p");
      distance.className = "store-locator__item-distance";
      distance.textContent = "Distance: " + location.distanceMiles.toFixed(1) + " mi";
      content.appendChild(distance);
    }

    var address = document.createElement("p");
    address.className = "store-locator__item-address";
    address.innerHTML =
      escapeHtml(location.address) +
      (location.address && location.city ? ", " : "") +
      escapeHtml(location.city) +
      (location.city && location.state ? ", " : "") +
      escapeHtml(location.state) +
      " " +
      escapeHtml(location.zip);
    content.appendChild(address);

    if (location.notes) {
      var notes = document.createElement("p");
      notes.className = "store-locator__item-notes";
      notes.textContent = location.notes;
      content.appendChild(notes);
    }

    var directions = document.createElement("a");
    directions.className = "store-locator__directions";
    directions.href = buildDirectionsUrl(location);
    directions.target = "_blank";
    directions.rel = "noopener noreferrer";
    directions.textContent = "Get directions";
    directions.setAttribute("aria-label", "Get directions to " + location.name);
    content.appendChild(directions);

    return card;
  }

  function debounce(fn, delay) {
    var timeoutId = null;
    return function () {
      var args = arguments;
      window.clearTimeout(timeoutId);
      timeoutId = window.setTimeout(function () {
        fn.apply(null, args);
      }, delay);
    };
  }

  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      var existing = document.querySelector('script[src="' + src + '"]');
      if (existing) {
        if (existing.dataset.loaded === "true") {
          resolve();
          return;
        }
        existing.addEventListener("load", resolve);
        existing.addEventListener("error", function () {
          reject(new Error("Failed to load script: " + src));
        });
        return;
      }

      var script = document.createElement("script");
      script.src = src;
      script.async = true;
      script.defer = true;
      script.addEventListener("load", function () {
        script.dataset.loaded = "true";
        resolve();
      });
      script.addEventListener("error", function () {
        reject(new Error("Failed to load script: " + src));
      });
      document.head.appendChild(script);
    });
  }

  function loadStylesheet(href) {
    return new Promise(function (resolve, reject) {
      var existing = document.querySelector('link[href="' + href + '"]');
      if (existing) {
        resolve();
        return;
      }

      var link = document.createElement("link");
      link.rel = "stylesheet";
      link.href = href;
      link.addEventListener("load", resolve);
      link.addEventListener("error", function () {
        reject(new Error("Failed to load stylesheet: " + href));
      });
      document.head.appendChild(link);
    });
  }

  function StoreLocator(root) {
    this.root = root;
    this.searchInput = root.querySelector("[data-store-search-input]");
    this.radiusSelect = root.querySelector("[data-store-radius]");
    this.clearButton = root.querySelector("[data-store-clear]");
    this.resultsEl = root.querySelector("[data-store-results]");
    this.showMoreButton = root.querySelector("[data-store-show-more]");
    this.statusEl = root.querySelector("[data-store-status]");
    this.mapToggle = root.querySelector("[data-store-map-toggle]");
    this.mapWrap = root.querySelector(".store-locator__map-wrap");
    this.mapEl = root.querySelector("[data-store-map]");
    this.locationScript = root.querySelector("[data-store-locations]");
    this.limit = Number(root.dataset.resultsLimit || 20);
    this.noResultsText = root.dataset.noResultsText || "No matching stores found.";
    this.emptyStateText = root.dataset.emptyStateText || "No store locations available yet.";
    this.showMoreLabel = root.dataset.showMoreLabel || "Show more";
    this.mapEnabled = root.dataset.mapEnabled === "true";
    this.mapProvider = root.dataset.mapProvider || "none";
    this.mapApiKey = root.dataset.mapApiKey || "";
    this.proximityEnabled = root.dataset.proximityEnabled === "true";
    this.defaultRadius = Number(root.dataset.defaultRadius || 50);
    this.geocodeCountry = String(root.dataset.geocodeCountry || "US").trim().toUpperCase();
    this.locations = [];
    this.filtered = [];
    this.map = null;
    this.mapMarkers = [];
    this.mapLoaded = false;
    this.debugMode = typeof window.Shopify !== "undefined" && window.Shopify.designMode;
    this.searchToken = 0;
    this.zipGeocodeCache = {};
    this.hasCoordinateLocations = false;
    this.defaultMapRadiusMiles = 60;
    this.mapAlwaysOpen = true;
    this.pageSize = 8;
    this.visibleCount = 0;
    this.currentMatches = [];
    this.currentTotalMatches = 0;
    this.currentContext = { mode: "all" };
  }

  StoreLocator.prototype.init = function () {
    if (!this.searchInput || !this.resultsEl || !this.locationScript) {
      return;
    }

    this.locations = this.loadLocations();
    this.locations.sort(function (a, b) {
      var aOrder = a.sort_order === null ? Number.MAX_SAFE_INTEGER : a.sort_order;
      var bOrder = b.sort_order === null ? Number.MAX_SAFE_INTEGER : b.sort_order;
      if (aOrder !== bOrder) return aOrder - bOrder;
      return a.name.localeCompare(b.name);
    });
    this.hasCoordinateLocations = this.locations.some(function (location) {
      return location.latitude !== null && location.longitude !== null;
    });

    if (this.radiusSelect && Number.isFinite(this.defaultRadius)) {
      this.radiusSelect.value = String(this.defaultRadius);
    }

    this.attachEvents();
    this.configureMapUi();
    this.executeSearch("");

    if (this.mapEnabled && this.mapProvider !== "none") {
      this.root.classList.add("store-locator--map-open");
      if (this.mapToggle && this.mapAlwaysOpen) {
        this.mapToggle.style.display = "none";
      } else if (this.mapToggle) {
        this.mapToggle.textContent = "Hide map";
      }
      this.loadMap().catch(
        function () {
          this.disableMap("Map unavailable. List view is still available.");
        }.bind(this)
      );
    }
  };

  StoreLocator.prototype.emitEvent = function (eventName, detail) {
    this.root.dispatchEvent(
      new CustomEvent("store-locator:" + eventName, {
        bubbles: true,
        detail: detail || {}
      })
    );
  };

  StoreLocator.prototype.loadLocations = function () {
    var parsed = safeParseJson(this.locationScript.textContent);
    var raw = Array.isArray(parsed) ? parsed : Array.isArray(parsed && parsed.locations) ? parsed.locations : [];

    if (raw.length === 0) {
      var fallbackRaw = decodeHtmlEntities(this.root.dataset.fallbackJson || "");
      var fallbackParsed = safeParseJson(fallbackRaw);
      raw = Array.isArray(fallbackParsed)
        ? fallbackParsed
        : Array.isArray(fallbackParsed && fallbackParsed.locations)
          ? fallbackParsed.locations
          : [];
    }

    var normalized = [];
    var invalidRows = 0;
    for (var i = 0; i < raw.length; i += 1) {
      var entry = normalizeLocation(raw[i], i);
      if (entry) {
        normalized.push(entry);
      } else {
        invalidRows += 1;
      }
    }

    if (invalidRows > 0 && this.debugMode && typeof console !== "undefined") {
      console.warn("[Store Locator] Ignored invalid location rows:", invalidRows);
    }

    return normalized;
  };

  StoreLocator.prototype.attachEvents = function () {
    var self = this;
    var onInput = debounce(function () {
      self.executeSearch(self.searchInput.value || "");
    }, 120);

    this.searchInput.addEventListener("input", onInput);

    if (this.radiusSelect) {
      this.radiusSelect.addEventListener("change", function () {
        self.executeSearch(self.searchInput.value || "");
      });
    }

    this.clearButton.addEventListener("click", function () {
      self.searchInput.value = "";
      self.searchInput.focus();
      if (self.radiusSelect) {
        self.radiusSelect.value = String(self.defaultRadius);
      }
      self.executeSearch("");
    });

    if (this.mapToggle && !this.mapAlwaysOpen) {
      this.mapToggle.addEventListener("click", function () {
        self.root.classList.toggle("store-locator--map-open");
        self.emitEvent("map_toggle", {
          provider: self.mapProvider,
          open: self.root.classList.contains("store-locator--map-open")
        });
        if (self.mapToggle) {
          self.mapToggle.textContent = self.root.classList.contains("store-locator--map-open")
            ? "Hide map"
            : "Show map";
        }
        if (!self.mapLoaded) {
          self.loadMap().catch(function () {
            self.disableMap("Map unavailable. List view is still available.");
          });
        } else if (self.map) {
          if (typeof self.map.resize === "function") {
            self.map.resize();
          }
          if (typeof self.map.invalidateSize === "function") {
            self.map.invalidateSize();
          }
        }
      });
    }

    this.resultsEl.addEventListener("click", function (event) {
      var target = event.target;
      if (!(target instanceof HTMLElement)) return;
      var link = target.closest(".store-locator__directions");
      if (!link) return;
      var card = link.closest(".store-locator__item");
      var nameNode = card ? card.querySelector(".store-locator__item-name") : null;
      self.emitEvent("directions_click", {
        locationName: nameNode ? nameNode.textContent : null,
        href: link.getAttribute("href")
      });
    });

    if (this.showMoreButton) {
      this.showMoreButton.textContent = this.showMoreLabel;
      this.showMoreButton.addEventListener("click", function () {
        if (self.visibleCount >= self.currentMatches.length) {
          return;
        }
        self.visibleCount = Math.min(self.visibleCount + self.pageSize, self.currentMatches.length);
        self.filtered = self.currentMatches.slice(0, self.visibleCount);
        self.renderResults(self.currentTotalMatches, self.currentContext);
        self.renderMapMarkers();
      });
    }
  };

  StoreLocator.prototype.setMatches = function (matches, totalMatches, context) {
    this.currentMatches = matches.slice(0, this.limit);
    this.currentTotalMatches = totalMatches;
    this.currentContext = context || { mode: "text" };
    this.visibleCount = Math.min(this.pageSize, this.currentMatches.length);
    this.filtered = this.currentMatches.slice(0, this.visibleCount);
  };

  StoreLocator.prototype.getSelectedRadiusMiles = function () {
    if (!this.radiusSelect) {
      return this.defaultRadius;
    }
    var n = Number(this.radiusSelect.value || this.defaultRadius);
    if (n === 25 || n === 50 || n === 100) return n;
    return this.defaultRadius;
  };

  StoreLocator.prototype.shouldUseProximitySearch = function (query) {
    if (!this.proximityEnabled) return false;
    if (!isZipCode(query)) return false;
    if (!this.hasCoordinateLocations) return false;
    if (this.mapProvider === "leaflet") return true;
    if (!this.mapApiKey) return false;
    if (this.mapProvider !== "mapbox" && this.mapProvider !== "google") return false;
    return true;
  };

  StoreLocator.prototype.executeSearch = async function (query) {
    var token = ++this.searchToken;

    if (!this.locations.length) {
      this.resultsEl.innerHTML = '<p class="store-locator__message">' + escapeHtml(this.emptyStateText) + "</p>";
      this.statusEl.textContent = "0 locations";
      this.currentMatches = [];
      this.filtered = [];
      if (this.showMoreButton) {
        this.showMoreButton.hidden = true;
      }
      return;
    }

    var normalizedQuery = normalizeText(query);
    if (!normalizedQuery) {
      this.setMatches(this.locations, this.locations.length, { mode: "all" });
      this.renderResults(this.locations.length, { mode: "all" });
      this.renderMapMarkers();
      this.emitEvent("search", {
        mode: "all",
        query: "",
        totalMatches: this.locations.length,
        shown: this.filtered.length
      });
      return;
    }

    if (this.shouldUseProximitySearch(normalizedQuery)) {
      var radius = this.getSelectedRadiusMiles();
      this.statusEl.textContent = "Searching within " + radius + " miles of " + normalizedQuery + "...";
      var origin = await this.geocodeZip(normalizedQuery);
      if (token !== this.searchToken) return;

      if (origin) {
        var proximityMatches = this.locations
          .map(function (location) {
            if (location.latitude === null || location.longitude === null) {
              return null;
            }
            var distanceMiles = haversineMiles(origin.lat, origin.lng, location.latitude, location.longitude);
            if (distanceMiles > radius) {
              return null;
            }
            return Object.assign({}, location, {
              distanceMiles: distanceMiles
            });
          })
          .filter(Boolean)
          .sort(function (a, b) {
            return a.distanceMiles - b.distanceMiles;
          });

        this.setMatches(proximityMatches, proximityMatches.length, {
          mode: "proximity",
          radiusMiles: radius,
          zip: normalizedQuery
        });
        this.renderResults(proximityMatches.length, {
          mode: "proximity",
          radiusMiles: radius,
          zip: normalizedQuery
        });
        this.renderMapMarkers();
        this.emitEvent("search", {
          mode: "proximity",
          query: normalizedQuery,
          radiusMiles: radius,
          totalMatches: proximityMatches.length,
          shown: this.filtered.length
        });
        return;
      }
    }

    var textMatches = this.locations.filter(function (location) {
      return location.searchText.includes(normalizedQuery);
    });
    this.setMatches(textMatches, textMatches.length, { mode: "text" });
    this.renderResults(textMatches.length, { mode: "text" });
    this.renderMapMarkers();
    this.emitEvent("search", {
      mode: "text",
      query: normalizedQuery,
      totalMatches: textMatches.length,
      shown: this.filtered.length
    });
  };

  StoreLocator.prototype.renderResults = function (totalMatches, context) {
    this.resultsEl.innerHTML = "";
    var mode = context && context.mode ? context.mode : "text";

    if (!this.filtered.length) {
      this.resultsEl.innerHTML = '<p class="store-locator__message">' + escapeHtml(this.noResultsText) + "</p>";
      if (this.showMoreButton) {
        this.showMoreButton.hidden = true;
      }
      if (mode === "proximity" && context && context.radiusMiles && context.zip) {
        this.statusEl.textContent =
          "0 locations within " + context.radiusMiles + " miles of " + context.zip + ".";
      } else {
        this.statusEl.textContent = "0 locations";
      }
      return;
    }

    var fragment = document.createDocumentFragment();
    for (var i = 0; i < this.filtered.length; i += 1) {
      fragment.appendChild(createLocationCard(this.filtered[i]));
    }
    this.resultsEl.appendChild(fragment);

    if (this.showMoreButton) {
      this.showMoreButton.textContent = this.showMoreLabel;
      this.showMoreButton.hidden = this.visibleCount >= this.currentMatches.length;
    }

    var shown = this.filtered.length;
    if (mode === "proximity" && context && context.radiusMiles && context.zip) {
      this.statusEl.textContent =
        "Showing " +
        shown +
        " of " +
        totalMatches +
        " locations within " +
        context.radiusMiles +
        " miles of " +
        context.zip +
        ".";
    } else {
      this.statusEl.textContent = "Showing " + shown + " of " + totalMatches + " locations";
    }
  };

  StoreLocator.prototype.configureMapUi = function () {
    if (!this.mapWrap || !this.mapToggle) return;

    if (!this.mapEnabled || this.mapProvider === "none") {
      this.mapWrap.classList.add("is-hidden");
      this.mapToggle.disabled = true;
      this.mapToggle.setAttribute("aria-disabled", "true");
      this.mapToggle.textContent = "Map disabled";
      return;
    }

    if (this.mapAlwaysOpen) {
      this.root.classList.add("store-locator--map-open");
      this.mapToggle.style.display = "none";
    }
  };

  StoreLocator.prototype.disableMap = function (message) {
    if (this.mapWrap) {
      this.mapWrap.classList.add("is-hidden");
    }
    if (this.mapToggle) {
      this.mapToggle.disabled = true;
      this.mapToggle.setAttribute("aria-disabled", "true");
      this.mapToggle.textContent = "Map unavailable";
    }
    if (message && this.statusEl) {
      this.statusEl.textContent = message;
    }
  };

  StoreLocator.prototype.loadGoogleSdk = function () {
    var googleSrc = googleScriptBase + "?key=" + encodeURIComponent(this.mapApiKey) + "&loading=async";
    return loadScript(googleSrc);
  };

  StoreLocator.prototype.geocodeZip = async function (zip) {
    var cacheKey = this.geocodeCountry + ":" + zip;
    if (Object.prototype.hasOwnProperty.call(this.zipGeocodeCache, cacheKey)) {
      return this.zipGeocodeCache[cacheKey];
    }

    var result = null;
    try {
      if (this.mapProvider === "mapbox") {
        result = await this.geocodeZipMapbox(zip);
      } else if (this.mapProvider === "google") {
        result = await this.geocodeZipGoogle(zip);
      } else if (this.mapProvider === "leaflet") {
        result = await this.geocodeZipLeaflet(zip);
      }
    } catch (error) {
      if (this.debugMode && typeof console !== "undefined") {
        console.warn("[Store Locator] Zip geocoding failed:", error);
      }
    }

    this.zipGeocodeCache[cacheKey] = result;
    return result;
  };

  StoreLocator.prototype.geocodeZipMapbox = async function (zip) {
    var url =
      "https://api.mapbox.com/geocoding/v5/mapbox.places/" +
      encodeURIComponent(zip) +
      ".json?types=postcode&country=" +
      encodeURIComponent(this.geocodeCountry.toLowerCase()) +
      "&limit=1&autocomplete=false&access_token=" +
      encodeURIComponent(this.mapApiKey);

    var response = await fetch(url, { method: "GET" });
    if (!response.ok) {
      throw new Error("Mapbox geocoding error: " + response.status);
    }
    var data = await response.json();
    if (!data || !Array.isArray(data.features) || !data.features.length || !Array.isArray(data.features[0].center)) {
      return null;
    }

    var center = data.features[0].center;
    var lng = Number(center[0]);
    var lat = Number(center[1]);
    if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
    return { lat: lat, lng: lng };
  };

  StoreLocator.prototype.geocodeZipGoogle = async function (zip) {
    await this.loadGoogleSdk();
    if (!window.google || !window.google.maps || !window.google.maps.Geocoder) {
      return null;
    }

    var geocoder = new window.google.maps.Geocoder();
    var request = {
      address: zip,
      componentRestrictions: {
        country: this.geocodeCountry
      }
    };

    return new Promise(function (resolve) {
      geocoder.geocode(request, function (results, status) {
        if (status !== "OK" || !results || !results.length || !results[0].geometry || !results[0].geometry.location) {
          resolve(null);
          return;
        }
        resolve({
          lat: results[0].geometry.location.lat(),
          lng: results[0].geometry.location.lng()
        });
      });
    });
  };

  StoreLocator.prototype.geocodeZipLeaflet = async function (zip) {
    var endpoint =
      "https://nominatim.openstreetmap.org/search?postalcode=" +
      encodeURIComponent(zip) +
      "&countrycodes=" +
      encodeURIComponent(this.geocodeCountry.toLowerCase()) +
      "&format=jsonv2&limit=1";

    var response = await fetch(endpoint, {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    });

    if (!response.ok) {
      throw new Error("Nominatim geocoding error: " + response.status);
    }

    var data = await response.json();
    if (!Array.isArray(data) || !data.length) {
      return null;
    }

    var lat = Number(data[0].lat);
    var lng = Number(data[0].lon);
    if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
    return { lat: lat, lng: lng };
  };

  StoreLocator.prototype.loadMap = function () {
    var self = this;
    if (!this.mapEnabled || this.mapProvider === "none") {
      return Promise.resolve();
    }

    if (this.mapProvider === "mapbox") {
      if (!this.mapApiKey) {
        throw new Error("Missing Mapbox public key");
      }
      return loadStylesheet(mapboxCssUrl)
        .then(function () {
          return loadScript(mapboxScriptUrl);
        })
        .then(function () {
          if (!window.mapboxgl) {
            throw new Error("Mapbox failed to initialize");
          }
          window.mapboxgl.accessToken = self.mapApiKey;
          self.map = new window.mapboxgl.Map({
            container: self.mapEl,
            style: "mapbox://styles/mapbox/streets-v12",
            center: [-98.5795, 39.8283],
            zoom: 3
          });
          self.mapLoaded = true;
          self.emitEvent("map_loaded", { provider: "mapbox" });
          self.renderMapMarkers();
        });
    }

    if (this.mapProvider === "google") {
      if (!this.mapApiKey) {
        throw new Error("Missing Google Maps API key");
      }
      return this.loadGoogleSdk().then(function () {
        if (!window.google || !window.google.maps) {
          throw new Error("Google Maps failed to initialize");
        }
        self.map = new window.google.maps.Map(self.mapEl, {
          center: { lat: 39.8283, lng: -98.5795 },
          zoom: 3,
          mapTypeControl: false,
          streetViewControl: false
        });
        self.mapLoaded = true;
        self.emitEvent("map_loaded", { provider: "google" });
        self.renderMapMarkers();
      });
    }

    if (this.mapProvider === "leaflet") {
      return loadStylesheet(leafletCssUrl)
        .then(function () {
          return loadScript(leafletScriptUrl);
        })
        .then(function () {
          if (!window.L) {
            throw new Error("Leaflet failed to initialize");
          }
          self.map = window.L.map(self.mapEl, {
            scrollWheelZoom: false
          }).setView([39.8283, -98.5795], 3);
          window.L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
            maxZoom: 19,
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          }).addTo(self.map);
          self.mapLoaded = true;
          self.emitEvent("map_loaded", { provider: "leaflet" });
          self.renderMapMarkers();
        });
    }

    return Promise.resolve();
  };

  StoreLocator.prototype.renderMapMarkers = function () {
    if (!this.mapLoaded || !this.map) return;

    if (this.mapProvider === "mapbox") {
      for (var i = 0; i < this.mapMarkers.length; i += 1) {
        this.mapMarkers[i].remove();
      }
      this.mapMarkers = [];

      var bounds = new window.mapboxgl.LngLatBounds();
      var withCoords = this.filtered.filter(function (location) {
        return location.latitude !== null && location.longitude !== null;
      });

      withCoords.forEach(
        function (location) {
          var marker = new window.mapboxgl.Marker()
            .setLngLat([location.longitude, location.latitude])
            .setPopup(new window.mapboxgl.Popup({ offset: 12 }).setText(location.name))
            .addTo(this.map);
          this.mapMarkers.push(marker);
          bounds.extend([location.longitude, location.latitude]);
        }.bind(this)
      );

      if (withCoords.length > 1) {
        this.map.fitBounds(bounds, { padding: 50, maxZoom: 12 });
      } else if (withCoords.length === 1) {
        this.map.flyTo({ center: [withCoords[0].longitude, withCoords[0].latitude], zoom: 11 });
      }
      return;
    }

    if (this.mapProvider === "google") {
      for (var j = 0; j < this.mapMarkers.length; j += 1) {
        this.mapMarkers[j].setMap(null);
      }
      this.mapMarkers = [];

      var googleBounds = new window.google.maps.LatLngBounds();
      var count = 0;
      for (var k = 0; k < this.filtered.length; k += 1) {
        var location = this.filtered[k];
        if (location.latitude === null || location.longitude === null) continue;
        var marker = new window.google.maps.Marker({
          map: this.map,
          position: { lat: location.latitude, lng: location.longitude },
          title: location.name
        });
        this.mapMarkers.push(marker);
        googleBounds.extend(marker.getPosition());
        count += 1;
      }

      if (count > 1) {
        this.map.fitBounds(googleBounds);
      } else if (count === 1) {
        this.map.setCenter(googleBounds.getCenter());
        this.map.setZoom(11);
      }
      return;
    }

    if (this.mapProvider === "leaflet") {
      for (var m = 0; m < this.mapMarkers.length; m += 1) {
        this.map.removeLayer(this.mapMarkers[m]);
      }
      this.mapMarkers = [];

      var leafletBounds = [];
      for (var n = 0; n < this.filtered.length; n += 1) {
        var leafletLocation = this.filtered[n];
        if (leafletLocation.latitude === null || leafletLocation.longitude === null) continue;
        var marker = window.L.marker([leafletLocation.latitude, leafletLocation.longitude])
          .addTo(this.map)
          .bindPopup(escapeHtml(leafletLocation.name));
        this.mapMarkers.push(marker);
        leafletBounds.push([leafletLocation.latitude, leafletLocation.longitude]);
      }

      if (leafletBounds.length === 0) {
        this.statusEl.textContent = "Map is enabled, but locations need latitude/longitude to show markers.";
        return;
      }

      var noQuery = !normalizeText(this.searchInput && this.searchInput.value ? this.searchInput.value : "");
      if (noQuery) {
        var latTotal = 0;
        var lngTotal = 0;
        for (var q = 0; q < leafletBounds.length; q += 1) {
          latTotal += leafletBounds[q][0];
          lngTotal += leafletBounds[q][1];
        }
        var centerLat = latTotal / leafletBounds.length;
        var centerLng = lngTotal / leafletBounds.length;
        var sizeMeters = this.defaultMapRadiusMiles * 1609.344 * 2;
        var radiusBounds = window.L.latLng(centerLat, centerLng).toBounds(sizeMeters);
        this.map.fitBounds(radiusBounds, {
          padding: [20, 20],
          maxZoom: 11
        });
        return;
      }

      if (leafletBounds.length > 1) {
        this.map.fitBounds(leafletBounds, {
          padding: [30, 30],
          maxZoom: 12
        });
      } else if (leafletBounds.length === 1) {
        this.map.setView(leafletBounds[0], 11);
      }
    }
  };

  function initStoreLocatorSections(scope) {
    var root = scope || document;
    var sections = root.querySelectorAll("[data-store-locator]");
    sections.forEach(function (section) {
      if (section.dataset.storeLocatorReady === "true") {
        return;
      }
      section.dataset.storeLocatorReady = "true";
      new StoreLocator(section).init();
    });
  }

  document.addEventListener("DOMContentLoaded", function () {
    initStoreLocatorSections(document);
  });

  document.addEventListener("shopify:section:load", function (event) {
    if (event.target) {
      initStoreLocatorSections(event.target);
    }
  });
})();
